import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-isomasters-logo',
  templateUrl: './isomasters-logo.component.html',
  styleUrls: ['./isomasters-logo.component.scss'],
})
export class IsomastersLogoComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
